/**
 * Thrown when the frontend intentionally cancels an in-flight operation.
 *
 * Use this for every application-owned cancellation: recomputation of a Vue
 * async computed, scope disposal, navigation, or any other user/workflow
 * action that makes a previous request obsolete. Pass a concise, human-readable
 * message that explains why the cancellation happened.
 */
export class AppCancelError extends Error {
  override name = 'AppCancelError'
}

/**
 * Thrown when an underlying system abort occurs.
 *
 * Reserve this for aborts that originate below the frontend's control, such as
 * platform or runtime abort conditions.
 */
export class AppAbortError extends Error {
  override name = 'AppAbortError'
}
